<template>
  <div class="md-layout md-gutter moreInfoGroup">
    <div class="md-layout-item md-size-50">
      <md-field>
        <select v-model="$store.state.plot.localization.health_damage_type" name="damageType">
          <option disabled value="">{{ $t("localization.damageType") }}</option>
          <option v-for="(dt, key) in damageTypeList" :value="key" :key="key">{{ dt }}</option>
        </select>
      </md-field>
    </div>
    <div class="md-layout-item md-size-50">
      <md-field>
        <select v-model="$store.state.plot.localization.health_damage_intensity" name="damageIntensity">
          <option disabled value="">{{ $t("localization.damageIntensity") }}</option>
          <option v-for="(di, key) in damageIntensityList" :value="key" :key="key">{{ di }}</option>
        </select>
      </md-field>
    </div>
    <div class="md-layout-item md-size-50">
      <md-field :class="!checkPercentage($store.state.plot.localization.health_damage_area) ? 'md-invalid' : ''">
        <label for="damageArea">{{ $t("localization.damageArea")}} %</label>
        <md-input type="number" name="damageArea" v-model="$store.state.plot.localization.health_damage_area" />
        <span class="md-error">{{ $t("error.errorRange") }} (0-100)</span>
      </md-field>
    </div>
    <div class="md-layout-item md-size-50">
      <md-field>
        <select v-model="$store.state.plot.localization.health_main_reason" name="damageMainReason">
          <option disabled value="">{{ $t("localization.damageMainReason") }}</option>
          <option v-for="(dmr, key) in damageMainReasonList" :value="key" :key="key">{{ dmr }}</option>
        </select>
      </md-field>
    </div>
    <div class="md-layout-item md-size-50">
      <md-field :class="!checkPercentage($store.state.plot.localization.health_dead_tree) ? 'md-invalid' : ''">
        <label for="defoliationSup">{{ $t("localization.deadTree")}} %</label>
        <md-input type="number" name="deadTree" v-model="$store.state.plot.localization.health_dead_tree" />
        <span class="md-error">{{ $t("error.errorRange") }} (0-100)</span>
      </md-field>
    </div>
  </div>
</template>

<script>
import { getDomain } from '@/assets/scripts/domainsManager'
import { checkPercentage } from '@/assets/scripts/formatData'

const DAMAGE_TYPE = 'damage_type'
const DAMAGE_INTENSITY = 'damage_intensity'
const DAMAGE_MAIN_REASON = 'damage_main_reason'

export default {
  name: 'Health',
  data: () => ({
    checkPercentage: checkPercentage,
    damageTypeList: {},
    damageIntensityList: {},
    damageMainReasonList: {}
  }),
  mounted () {
    getDomain(DAMAGE_TYPE).then(data => {
      this.damageTypeList = data[this.$i18n.locale]
    })
    getDomain(DAMAGE_INTENSITY).then(data => {
      this.damageIntensityList = data[this.$i18n.locale]
    })
    getDomain(DAMAGE_MAIN_REASON).then(data => {
      this.damageMainReasonList = data[this.$i18n.locale]
    })
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';
</style>
